module.exports = __webpack_public_path__ + "static/media/vf_mdressshoes_core.5f6f8674.svg";